import React, { useCallback } from 'react';

import Dialog from 'components/Dialog';

const ModalRoute = ({ component, dialogAttr, history, location }) => {
	const onBack = useCallback(() => {
		const url = location.state?.background;
		if (url) {
			history.push(url);
		} else {
			history.goBack();
		}
	}, []);

	return (
		<Dialog
			size={dialogAttr?.size}
			title={dialogAttr?.title}
			height={dialogAttr?.height}
			onClose={onBack}
		>
			{component}
		</Dialog>
	);
};

export default ModalRoute;
